module.exports = __webpack_public_path__ + "static/media/Nepzalogo.d2486c36.png";